























































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import Card from "@/components/Card.vue";
import DonutChart from "@/components/Charts/DonutChart.vue";

import NoteListComponent from "@/components/NoteListComponent.vue";

// import { userService } from "@/services/user.service";
import { noteService } from "../services/note.service";
import { CardModel } from "@/models/card.model";
import { NoteList } from "../models/note.model";
import { ConsoleLogger } from "@microsoft/signalr/dist/esm/Utils";
import Modal from "./Modal.vue";

@Component({
    computed: mapGetters({
        totJobDone: "job/getJobDoneNumber",
        totJob: "job/getJobNumber",
        totJobRemaining: "job/getJobRemainingNumber",
    }),
    components: {
        Modal,
        Card,
        DonutChart,
        NoteListComponent,
    },
})
export default class PinBoardPage extends Vue {
    @Prop() private pinBoardId!: number;
    @Prop() private cardId!: string;
    showStatistics: boolean = false;
    vm: any = new Vue();

    noteLists: NoteList[] = [];

    getDraggableOptions() {
        return { group: "user-cards", handle: ".card-header" };
    }

    intervalId: any;
    // users: User[] = [];
    cards: Card[] = [];

    async created() {}

    destroyed() {
        clearInterval(this.intervalId);
    }

    async loadNoteLists(pinBoardId: number) {
        this.noteLists = [];
        this.noteLists = await noteService.getNoteLists(pinBoardId);
        // console.log(this.noteLists);
    }

    async loadCards() {
        await this.$store.dispatch("card/getCardsOnPinBoard", this.pinBoardId);
        // this.cards = this.userName != "" ? this.cards.filter(c => c. === this.userName) : this.users.sort((a,b) => { return a.firstName.localeCompare(b.firstName); });
    }

    async loadJobs() {
        await this.$store.dispatch("job/getJobsOnPinBoard", this.pinBoardId);
    }

    async createNoteList() {
        let newNoteList: NoteList = {
            title: "Anteckningar",
            pinboardId: this.pinBoardId,
        };
        var result = await noteService.createNoteList(newNoteList);
        if (result) {
            newNoteList.id = result.data;
            this.noteLists.push(newNoteList);
        }
    }

    async deleteNoteList(id: number) {
        //@ts-ignore
        if (await this.$refs.confirmModal.open("Vill du ta bort anteckningsblocket")) {
            var result = await noteService.deleteNoteList(id);

            if (result) {
                let index = this.noteLists.findIndex((n) => n.id == id);
                this.noteLists.splice(index, 1);
            }
        }
    }

    get getSettings() {
        return this.$store.getters["app/setting"];
    }

    get currentPinBoard() {
        return this.$store.getters["app/currentPinBoard"];
    }

    // *********************** //
    // *** cardsOnPinBoard *** //
    // *********************** //

    get cardsOnPinBoard() {
        let list = this.$store.getters[
            "card/getCardsOnPinBoard"
        ] as CardModel[];
        if (this.cardId) {
            return list.filter((l) => l.id == (this.cardId as any));
        }

        let alphaSort = list.sort((a, b) => {
            return a.name!.localeCompare(b.name!);
        });
        let showFirstSort = alphaSort.sort((a, b) => {
            return (b.showFirst ? 1 : 0) - (a.showFirst ? 1 : 0);
        });

        return list.sort((a: CardModel, b: CardModel) => {
            return a.sortOrder! - b.sortOrder!;
        });
    }

    set cardsOnPinBoard(list: any) {
        list.forEach((card: CardModel, index: number) => {
            card.sortOrder = index;
        });

        this.$store.dispatch("card/updateCardsOrder", list);
    }

    // *********************** //
    // *** end cardsOnPinBoard *** //
    // *********************** //

    @Watch("cardId")
    async cardIdChanged() {
        await this.$store.dispatch("card/getCardsOnPinBoard", this.pinBoardId);
    }

    @Watch("pinBoardId")
    async pinBoardIdChanged() {
        if (this.pinBoardId != 0) {
            await this.loadCards();
            await this.loadNoteLists(this.pinBoardId);
            await this.loadJobs();
        } else alert("no pinboard!");
    }
}
